import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import React from 'react';
import { EditorBlock, EditorState, SelectionState } from 'draft-js';
import { getCurrentBlock } from 'medium-draft/lib/model';
import { strMapToObj } from '../../helpers';
var ImageBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageBlock, _React$Component);
  var _super = _createSuper(ImageBlock);
  function ImageBlock() {
    var _this;
    _classCallCheck(this, ImageBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "focusBlock", function () {
      var _this$props = _this.props,
        block = _this$props.block,
        blockProps = _this$props.blockProps;
      var getEditorState = blockProps.getEditorState,
        setEditorState = blockProps.setEditorState;
      var key = block.getKey();
      var editorState = getEditorState();
      var currentblock = getCurrentBlock(editorState);
      if (currentblock.getKey() === key) {
        return;
      }
      var newSelection = new SelectionState({
        anchorKey: key,
        focusKey: key,
        anchorOffset: 0,
        focusOffset: 0
      });
      setEditorState(EditorState.forceSelection(editorState, newSelection));
    });
    return _this;
  }
  _createClass(ImageBlock, [{
    key: "render",
    value: function render() {
      var block = this.props.block;
      var data = block.getData();
      var src = data.get('src');
      var attributes = strMapToObj(data);
      if (src !== null) {
        return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("div", {
          "data-test-id": "hp7hCcatvdkli5hljq3xn",
          className: "md-block-image-inner-container",
          role: "button",
          onClick: this.focusBlock,
          onKeyPress: this.focusBlock,
          tabIndex: 0
        }, void 0, /*#__PURE__*/React.createElement("img", attributes)), /*#__PURE__*/_jsx("figcaption", {}, void 0, /*#__PURE__*/React.createElement(EditorBlock, this.props)));
      }
      return /*#__PURE__*/React.createElement(EditorBlock, this.props);
    }
  }]);
  return ImageBlock;
}(React.Component);
export { ImageBlock as default };